import { Grid, Typography } from "@mui/material";
import Header from "components/Header/Header";
import PageArrows from "components/PageArrows/PageArrows";
import UserForm from "components/UserForm/UserForm";
import FavoriteSongsList from "components/lists/FavoriteSongsList/FavoriteSongsList";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import MainContainer from "components/styled/MainContainer";
import React, { useContext, useEffect, useState } from "react";
import { PageContext } from "utils/PageContext";
import { UserContext } from "utils/UserContext";
import { PAGES } from "utils/constants";

function FavoriteSongs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const {
    selectedScoreType,
    isDoingAnotherScore,
  } = useContext(UserContext);

  const { setPage } = useContext(PageContext);

  const connectionType = () => {
    switch (selectedScoreType) {
      case "Nostalgia":
        return "past";
      case "React":
        return "first";
      case "Rotation":
        return "recent";
      default:
        return null;
    }
  };

  const [open, setOpen] = useState(false);
  const handleOpenForm = () => setOpen(true);
  const handleCloseForm = () => setOpen(false);

  const handlePrevPage = () => {
    setPage(PAGES.SORT);
  };

  const handleNextPage = () => {
    !isDoingAnotherScore ? handleOpenForm() : setPage(PAGES.FINALSCORE);
  };

  return (
    <>
      <Header />
      <CenteredColumnGrid
        container
        sx={{
          paddingTop: "calc(2rem + 100px)",
          textAlign: "center",
        }}
      >
        <Grid item>
          <Typography
            component="h1"
            variant="directions"
            sx={{
              padding: "0 1rem",
            }}
          >
            Select up to 3 of your favorite songs from your {connectionType()}{" "}
            listens to this project.
          </Typography>
        </Grid>
      </CenteredColumnGrid>
      <MainContainer component="main">
        <CenteredColumnGrid container>
          <Grid item sm={8}>
            <FavoriteSongsList />
          </Grid>
        </CenteredColumnGrid>
      </MainContainer>
      <PageArrows
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
        isPageComplete
      />

      {!isDoingAnotherScore && (
        <UserForm open={open} handleCloseForm={handleCloseForm} />
      )}
    </>
  );
}

export default FavoriteSongs;
